import routes from '@config/routes';
import { serverFetcher } from '@instance';
import devConsole from '@utils/developer-console';

export const postFollowEvent = async (
  favoriteId: number,
  type: string,
  name: string,
  token?: string
) => {
  try {
    return await serverFetcher(routes.favorite, {
      method: 'POST',
      body: JSON.stringify({ favoriteId, type, name }),
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    devConsole(`postFollowEvent - ${err}`);
    return { error: 'Something went wrong. Please try again later.' };
  }
};

export const deleteFollowEvent = async (
  favoriteId: number,
  type: string,
  token?: string
) => {
  try {
    return await serverFetcher(routes.favorite, {
      method: 'DELETE',
      body: JSON.stringify({ favoriteId, type }),
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    devConsole(`deleteFollowEvent - ${err}`);
    return { error: 'Something went wrong. Please try again later.' };
  }
};
